/* eslint-disable max-len */
import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { UIChart } from 'primeng/chart';
import { LANGUAGES } from 'src/app/conf/languages';
import { AccessoryPower, BoardPower } from 'src/app/model/device-bus';
import { AppState } from 'src/app/store/app.reducer';
import * as UserActions from 'src/app/store/user/user.actions';
import * as NotificationsActions from "src/app/store/notifications/notifications.actions";
import { Observable, Subscription } from 'rxjs';
import { User } from 'src/app/model/user';
import { selectUser } from 'src/app/store/user/user.selector';
import { StandardPageLayout } from '../shared/stdlayoutlib/classes.stdlayoutlib';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmationService } from 'primeng/api';

@Component({
	selector: 'app-green-power3',
	templateUrl: './green-power3.component.html',
	providers: [ConfirmationService, DialogService]
})
export class GreenPower3Component implements OnInit, OnDestroy {
	@ViewChild('total') chart: UIChart;

	user$: Observable<User | undefined>;
	userSub: Subscription | undefined;

	listBus: BoardPower[];
	busSelect: BoardPower | undefined;

	listGateway: AccessoryPower[];
	listFotocelluleBus: AccessoryPower[];
	listSelettoriBus: AccessoryPower[];
	listInterfaccieBus: AccessoryPower[];
	listLampeggiantiBus: AccessoryPower[];
	listFotocell: AccessoryPower[];
	listSelR: AccessoryPower[];
	listLampeggiantiOld: AccessoryPower[];
	listSchede: AccessoryPower[];
	valueGreenPower = [];

	maxGateway: number;
	maxSchede: number;
	maxFotocelluleBus: number;
	maxSelettoriBus: number;
	maxInterfaccieBus: number;
	maxLampeggiantiBus: number;
	maxFotocelluleOld: number;
	maxSelettoriOld: number;
	maxLampeggiantiOld: number;

	totalSchede: number;
	totalGateway: number;
	totalFotocelluleBus: number;
	totalSelettoriBus: number;
	totalInterfaccieBus: number;
	totalLampeggiantiBus: number;
	totalFotocelluleOld: number;
	totalSelettoriOld: number;
	totalLampeggiantiOld: number;

	// GREEN POWER
	totalGreenLoadBoard: number;
	totalGreenLoadGateway: number;
	totalGreenLoadSchede: number;
	totalGreenLoadFotocelluleBus: number;
	totalGreenLoadSelettoriBus: number;
	totalGreenLoadInterfaccieBus: number;
	totalGreenLoadLampeggiantiBus: number;
	totalGreenLoadFotocelluleOld: number;
	totalGreenLoadSelettoriOld: number;
	totalGreenLoadLampeggiantiOld: number;
	totalGreenPower: number;
	totalGreenPowerBus: number;

	totalGreenLoadBoardPercentage: number;
	totalGreenLoadGatewayPercentage: number;
	totalGreenLoadSchedePercentage: number;
	totalGreenLoadFotocelluleBusPercentage: number;
	totalGreenLoadSelettoriBusPercentage: number;
	totalGreenLoadInterfaccieBusPercentage: number;
	totalGreenLoadLampeggiantiBusPercentage: number;
	totalGreenLoadFotocelluleOldPercentage: number;
	totalGreenLoadSelettoriOldPercentage: number;
	totalGreenLoadLampeggiantiOldPercentage: number;
	totalGreenLoadBusPercentage: number;
	// GREEN POWER


	totalLoadBoardPercentageLimitGreenPower: number;
	totalLoadGatewayPercentageLimitGreenPower: number;
	totalLoadSchedePercentageLimitGreenPower: number;
	totalLoadFotocelluleBusPercentageLimitGreenPower: number;
	totalLoadSelettoriBusPercentageLimitGreenPower: number;
	totalLoadInterfaccieBusPercentageLimitGreenPower: number;
	totalLoadLampeggiantiBusPercentageLimitGreenPower: number;
	totalLoadFotocelluleOldPercentageLimitGreenPower: number;
	totalLoadSelettoriOldPercentageLimitGreenPower: number;
	totalLoadLampeggiantiOldPercentageLimitGreenPower: number;


	totalLoadFotocelluleBusPercentageBus: number;
	totalLoadSelettoriBusPercentageBus: number;
	totalLoadInterfaccieBusPercentageBus: number;
	totalLoadLampeggiantiBusPercentageBus: number;
	statusLimitGreenPower: number;

	listColor = ["yellow", "RosyBrown", "purple", "orange", "green",
		"blue", "pink", "brown", "lightgreen", "lightblue"
	];
	//maxGateway-0-red
	//maxSchede-1-purple
	//maxSelettoriBus-2-orange
	//maxFotocelluleBus-3-green
	//maxInterfaccieBus-4-blue
	//maxLampeggiantiBus-5-pink
	//maxSelettoriOld-6-brown
	//maxFotocelluleOld-7-lightgreen
	//maxLampeggiantiOld-8-lightblue


	BX704_ZBX7N = {
		id: 1, name: 'BX704/708-ZBX7N', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.8, maxPowerGreen: 2.3, cxn: 0,
		maxGateway: 10, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
		maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 4, maxLampeggiantiOld: 2
	}
	BX608_ZBX6N = {
		id: 2, name: 'BX608-ZBX6N', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,  // NO GATEWAY NO R700-R800
		powerGreen: 0.5, maxPowerGreen: 2.3, cxn: 0,
		maxGateway: 10, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
		maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 2, maxLampeggiantiOld: 2
	}
	BKV_ZN7 = {
		id: 3, name: 'BXV-ZN7', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.5, maxPowerGreen: 2.3, cxn: 0,
		maxGateway: 10, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
		maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 4, maxLampeggiantiOld: 2
	}
	BKV_RAPID_ZN7 = {
		id: 4, name: 'BXV RAPID-ZN7V', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.5, maxPowerGreen: 2.3, cxn: 0,
		maxGateway: 10, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
		maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 4, maxLampeggiantiOld: 2
	}
	ZL65 = {
		id: 5, name: 'ZL65', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.5, maxPowerGreen: 2.3, cxn: 0,
		maxGateway: 10, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
		maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 4, maxLampeggiantiOld: 2
	}
	FA7024CB_ZL65 = {
		id: 6, name: 'FA7024CB/FST23DLC-ZL65', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.5, maxPowerGreen: 2.3, cxn: 0,
		maxGateway: 10, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
		maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 4, maxLampeggiantiOld: 2
	}
	FTX20DGC_ZL65 = {
		id: 7, name: 'FTX20DGC/FTX20DLC-ZL65', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.5, maxPowerGreen: 2.3, cxn: 0,
		maxGateway: 10, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
		maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 4, maxLampeggiantiOld: 2
	}
	VER_ZL57 = {
		id: 8, name: 'VER PLUS-ZL57', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.5, maxPowerGreen: 2.3, cxn: 0,
		maxGateway: 10, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
		maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 4, maxLampeggiantiOld: 2
	}
	ZLX24M = {
		id: 9, name: 'ZLX24M', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.8, maxPowerGreen: 2.3, cxn: 15,
		maxGateway: 10, maxSchede: 1, maxFotocelluleBus: 8, maxSelettoriBus: 8, maxInterfaccieBus: 2,
		maxLampeggiantiBus: 2, maxFotocelluleOld: 8, maxSelettoriOld: 0, maxLampeggiantiOld: 2
	}
	ZLX24S = {
		id: 10, name: 'ZLX24S', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.8, maxPowerGreen: 2.3, cxn: 15,
		maxGateway: 10, maxSchede: 1, maxFotocelluleBus: 8, maxSelettoriBus: 8, maxInterfaccieBus: 2,
		maxLampeggiantiBus: 2, maxFotocelluleOld: 8, maxSelettoriOld: 0, maxLampeggiantiOld: 2
	}
	ZM3E = {
		id: 11, name: 'ZM3E', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.5, maxPowerGreen: 2.3, cxn: 0,
		maxGateway: 10, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
		maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 4, maxLampeggiantiOld: 2
	}
	ZF1N = {
		id: 12, name: 'ZF1N', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,// NO GATEWAY NO R700-R800
		powerGreen: 0.5, maxPowerGreen: 2.3, cxn: 0,
		maxGateway: 10, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
		maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 4, maxLampeggiantiOld: 2
	}
	FA70230CB_ZF1N = {
		id: 13, name: 'FA70230CB-ZF1N', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,// NO GATEWAY NO R700-R800
		powerGreen: 0.5, maxPowerGreen: 2.3, cxn: 0,
		maxGateway: 10, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
		maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 4, maxLampeggiantiOld: 2
	}
	EMEGA_ZL43 = {
		id: 14, name: 'EMEGA-ZL43', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,// NO GATEWAY NO R700-R800
		powerGreen: 0.8, maxPowerGreen: 2.3, cxn: 0,
		maxGateway: 10, maxSchede: 1, maxFotocelluleBus: 0, maxSelettoriBus: 0, maxInterfaccieBus: 0,
		maxLampeggiantiBus: 0, maxFotocelluleOld: 8, maxSelettoriOld: 4, maxLampeggiantiOld: 2
	}
	BKX_ZBB3 = {
		id: 15, name: 'BKX-ZBB3', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.8, maxPowerGreen: 2.3, cxn: 15,
		maxGateway: 10, maxSchede: 1, maxFotocelluleBus: 8, maxSelettoriBus: 8, maxInterfaccieBus: 2,
		maxLampeggiantiBus: 2, maxFotocelluleOld: 8, maxSelettoriOld: 0, maxLampeggiantiOld: 2
	}
	ZLB24S = {
		id: 16, name: 'ZLB24S', maxPower: 40, limitGreenPower: 0.5, supportGreenPower: true, power: 5,
		powerGreen: 0.8, maxPowerGreen: 2.3, cxn: 15,
		maxGateway: 10, maxSchede: 1, maxFotocelluleBus: 8, maxSelettoriBus: 8, maxInterfaccieBus: 2,
		maxLampeggiantiBus: 2, maxFotocelluleOld: 8, maxSelettoriOld: 0, maxLampeggiantiOld: 2
	}
	browserDeviceScreen = 960;

	visibleCameInfo = true;

	guest = true;


	// design
	acceptButtonStyle: string;
	rejectButtonStyle: string;
	screenWidth: number;
	MIN_MD_WIDTH = 500;
	MIN_MD_WIDTH_EXT = 670;
	MAX_MD_WIDTH = 1120;
	MIN_WIDTH_COL4 = 1530;
	MIN_WIDTH_MX7 = 1700;

	constructor(
		private route: ActivatedRoute,
		private translate: TranslateService,
		private store: Store<AppState>,
		public dialogService: DialogService,
		public confirmationService: ConfirmationService,
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		// Store selectors
		this.user$ = this.store.select(selectUser);
	}

	ngOnDestroy(): void {
		this.userSub?.unsubscribe();
	}

	ngOnInit() {
		this.userSub = this.user$?.subscribe(currentUser => {
			if (currentUser !== undefined && currentUser.Email !== undefined && currentUser.Email !== '') {
				this.guest = false;
			}
		});
		this.store.dispatch(NotificationsActions.setTopbarTitleId({
			stringId: 'CALCULATION_POWER_PAGE_TITLE'
		}));
		const lang = this.route.snapshot.queryParamMap.get('language');
		const langVal = LANGUAGES.find(l => l.code === lang);
		if (langVal !== undefined) {
			this.store.dispatch(UserActions.setCurrentLang({ lang: langVal }));
			if (langVal.code !== this.translate.currentLang && localStorage != null) {
				window.location.reload();
			}
		}

		this.browserDeviceScreen = window.screen.width;
		this.listBus = [];
		this.listBus.push(this.BX704_ZBX7N);
		this.listBus.push(this.BX608_ZBX6N);
		this.listBus.push(this.BKV_ZN7);
		this.listBus.push(this.BKV_RAPID_ZN7);
		this.listBus.push(this.ZL65);
		this.listBus.push(this.FA7024CB_ZL65);
		this.listBus.push(this.FTX20DGC_ZL65);
		this.listBus.push(this.VER_ZL57);
		this.listBus.push(this.ZLX24M);
		this.listBus.push(this.ZLX24S);
		this.listBus.push(this.ZM3E);
		this.listBus.push(this.ZF1N);
		this.listBus.push(this.FA70230CB_ZF1N);
		this.listBus.push(this.EMEGA_ZL43);
		this.listBus.push(this.BKX_ZBB3);
		this.listBus.push(this.ZLB24S);
		this.busSelect = this.listBus[0];


		this.listGateway = [];
		this.listGateway.push(new AccessoryPower(1, 'Gateway', 'BUS_CAME_KEY', 0.5, 0.7, 8,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listGateway.push(new AccessoryPower(2, 'Gateway', 'BUS_GATEWAY_WIFI', 0.5, 1, 8,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listGateway.push(new AccessoryPower(3, 'Gateway', 'BUS_SLAVE', 0.5, 0.5, 8,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listGateway.push(new AccessoryPower(4, 'Gateway', 'BUS_RSLV', 0.5, 0.5, 8,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listGateway.push(new AccessoryPower(5, 'Gateway', 'BUS_RGSM', 4, 4, 8,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listGateway.push(new AccessoryPower(6, 'Gateway', 'BUS_GATEWAY_4G', 4, 4, 8,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));

		this.listFotocelluleBus = [];
		this.listFotocelluleBus.push(new AccessoryPower(1, 'Fotocellule Bus', 'BUS_CALC_PHO_DLX_BUS_DXR_BUS', 0.35, 0.35, 2,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));

		this.listSelettoriBus = [];
		this.listSelettoriBus.push(new AccessoryPower(1, 'Selettori Bus', 'BUS_CALC_SEL_KEYPAD', 0.35, 0.35, 2,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listSelettoriBus.push(new AccessoryPower(2, 'Selettori Bus', 'BUS_CALC_SEL_RFID_TRA', 0.35, 0.35, 2,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listSelettoriBus.push(new AccessoryPower(3, 'Selettori Bus', 'BUS_CALC_SEL_MIFARE_TRA', 1, 1, 2,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listSelettoriBus.push(new AccessoryPower(4, 'Selettori Bus', 'BUS_CALC_SEL_BLE', 1, 1, 2,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listSelettoriBus.push(new AccessoryPower(5, 'Selettori Bus', 'BUS_CALC_SEL_KEY_SEL', 0.35, 0.35, 2,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));

		this.listInterfaccieBus = [];
		this.listInterfaccieBus.push(new AccessoryPower(1, 'Interfacce Bus', 'BUS_CALC_INT_MODULE', 0.35, 0.35, 2,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));

		this.listLampeggiantiBus = [];
		this.listLampeggiantiBus.push(new AccessoryPower(1, 'Lampeggianti Bus', 'BUS_CALC_FLA_KRX', 0.5, 3.5, 0,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listLampeggiantiBus.push(new AccessoryPower(2, 'Lampeggianti Bus', 'BUS_CALC_FLA_GW_KRX', 1.5, 5, 0,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));


		this.listSchede = [];
		this.listSchede.push(new AccessoryPower(1, 'Schede', 'BUS_AF43S_AF868', 0, 0, 0,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listSchede.push(new AccessoryPower(2, 'Schede', 'BUS_RIO', 0.2, 0.2, 0,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listSchede.push(new AccessoryPower(3, 'Schede', 'BUS_R700', 0.4, 0.4, 2,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listSchede.push(new AccessoryPower(4, 'Schede', 'BUS_R800', 0.3, 0.3, 2,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		/*this.listSchede.push(new AccessoryPower(5, 'Schede', 'BUS_RCXN', 0.3, 0.3, 0,
			[this.ZN7.id, this.ZBX7N.id, this.ZL57.id, this.ZLX24.id, this.ZLX230.id]));*/

		this.listSelR = [];
		this.listSelR.push(new AccessoryPower(2, 'Selettori', 'BUS_TRASPONDER', 0.4, 0.4, 2,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listSelR.push(new AccessoryPower(1, 'Selettori', 'BUS_KEYPAD', 0.3, 0.3, 2,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));


		this.listFotocell = [];
		this.listFotocell.push(new AccessoryPower(1, 'Fotocellule', 'BUS_DIR_DLX_DELTA_DXR', 0, 0.1, 0,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));
		this.listFotocell.push(new AccessoryPower(2, 'Fotocellule', 'BUS_SMA', 0, 0, 0,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));

		this.listLampeggiantiOld = [];
		this.listLampeggiantiOld.push(new AccessoryPower(1, 'Lampeggianti', 'BUS_KLED', 0, 3, 0,
			[this.BX704_ZBX7N.id, this.BX608_ZBX6N.id, this.BKV_ZN7.id, this.BKV_RAPID_ZN7.id, this.ZL65.id, this.FA7024CB_ZL65.id,
			this.FTX20DGC_ZL65.id, this.VER_ZL57.id, this.ZLX24M.id, this.ZLX24S.id, this.ZM3E.id, this.ZF1N.id, this.FA70230CB_ZF1N.id,
			this.EMEGA_ZL43.id, this.BKX_ZBB3.id, this.ZLB24S.id]));

		this.busChange();

		const visibleCameInfoParam = this.route.snapshot.queryParamMap.get('cameInfo');
		if (visibleCameInfoParam != null && visibleCameInfoParam === 'false') {
			this.visibleCameInfo = false;
		}

		this.onResize();
	}

	resetForm(): void {
		this.totalGreenPower = this.busSelect.powerGreen;

		this.totalGreenLoadBoard = this.busSelect.powerGreen;

		// MAX DEVICE
		this.maxGateway = this.busSelect.maxGateway;
		this.maxSchede = this.busSelect.maxSchede;
		this.maxFotocelluleBus = this.busSelect.maxFotocelluleBus;
		this.maxSelettoriBus = this.busSelect.maxSelettoriBus;
		this.maxInterfaccieBus = this.busSelect.maxInterfaccieBus;
		this.maxLampeggiantiBus = this.busSelect.maxLampeggiantiBus;
		this.maxFotocelluleOld = this.busSelect.maxFotocelluleOld;
		this.maxSelettoriOld = this.busSelect.maxSelettoriOld;
		this.maxLampeggiantiOld = this.busSelect.maxLampeggiantiOld;
		// MAX DEVICE

		for (const device of this.listSchede) {
			device.quantity = 0;
		}
		for (const device of this.listGateway) {
			device.quantity = 0;
		}
		for (const device of this.listFotocelluleBus) {
			device.quantity = 0;
		}
		for (const device of this.listSelettoriBus) {
			device.quantity = 0;
		}
		for (const device of this.listInterfaccieBus) {
			device.quantity = 0;
		}
		for (const device of this.listLampeggiantiBus) {
			device.quantity = 0;
		}
		for (const device of this.listSelR) {
			device.quantity = 0;
		}
		for (const device of this.listFotocell) {
			device.quantity = 0;
		}
		for (const device of this.listLampeggiantiOld) {
			device.quantity = 0;
		}
		this.totalSchede = 0;
		this.totalGateway = 0;
		this.totalFotocelluleBus = 0;
		this.totalSelettoriBus = 0;
		this.totalInterfaccieBus = 0;
		this.totalLampeggiantiBus = 0;
		this.totalSelettoriOld = 0;
		this.totalFotocelluleOld = 0;
		this.totalLampeggiantiOld = 0;


		this.totalGreenLoadSchede = 0;
		this.totalGreenLoadGateway = 0;
		this.totalGreenLoadFotocelluleBus = 0;
		this.totalGreenLoadSelettoriBus = 0;
		this.totalGreenLoadInterfaccieBus = 0;
		this.totalGreenLoadLampeggiantiBus = 0;
		this.totalGreenLoadFotocelluleOld = 0;
		this.totalGreenLoadSelettoriOld = 0;
		this.totalGreenLoadLampeggiantiOld = 0;


		this.totalGreenLoadBusPercentage = 0;
		this.totalGreenLoadGatewayPercentage = 0;
		this.totalGreenLoadFotocelluleBusPercentage = 0;
		this.totalGreenLoadSelettoriBusPercentage = 0;
		this.totalGreenLoadInterfaccieBusPercentage = 0;
		this.totalGreenLoadLampeggiantiBusPercentage = 0;
		this.totalGreenLoadFotocelluleOldPercentage = 0;
		this.totalGreenLoadSelettoriOldPercentage = 0;
		this.totalGreenLoadLampeggiantiOldPercentage = 0;

		this.calculateDisabledAddDevice();
	}

	resetFormGateway(): void {
		for (const device of this.listFotocelluleBus) {
			const qt = device.quantity;
			for (let i = 0; i < qt; i++) {
				this.subtractOne(device);
			}
		}
		for (const device of this.listSelettoriBus) {
			const qt = device.quantity;
			for (let i = 0; i < qt; i++) {
				this.subtractOne(device);
			}
		}
		for (const device of this.listInterfaccieBus) {
			const qt = device.quantity;
			for (let i = 0; i < qt; i++) {
				this.subtractOne(device);
			}
		}
		for (const device of this.listLampeggiantiBus) {
			const qt = device.quantity;
			for (let i = 0; i < qt; i++) {
				this.subtractOne(device);
			}
		}
		for (const device of this.listFotocell) {
			const qt = device.quantity;
			for (let i = 0; i < qt; i++) {
				this.subtractOne(device);
			}
		}

		for (const device of this.listSelR) {
			const qt = device.quantity;
			for (let i = 0; i < qt; i++) {
				this.subtractOne(device);
			}
		}
		for (const device of this.listLampeggiantiOld) {
			const qt = device.quantity;
			for (let i = 0; i < qt; i++) {
				this.subtractOne(device);
			}
		}


	}

	busChange(): void {
		this.resetForm();
		this.calculateDisabledAddDevice();
	}

	checkSelectable(device: AccessoryPower) {
		if (device.listBusActive.includes(this.busSelect.id)) {
			return false;
		}
		return true;
	}

	enabledAddWithBoard(device: AccessoryPower) {
		if (device.family === 'Selettori' && device.id === 1) { // KEYPAD
			const find = this.listSchede.find(sc => sc.id === 4); //BUS_R800
			return find.quantity <= 0;
		}
		if (device.family === 'Selettori' && device.id === 2) { // TRASPONDER
			const find = this.listSchede.find(sc => sc.id === 3); // BUS_R700
			return find.quantity <= 0;
		}
		return true;
	}

	subtractOne(device: AccessoryPower) {
		if (device.family === 'Schede' && device.id === 3) { //BUS_R700
			const find = this.listSelR.find(sc => sc.id === 2); // BUS_TRASPONDER
			const qt = find.quantity;
			for (let i = 0; i < qt; i++) {
				this.subtractOne(find);
			}
		}
		if (device.family === 'Schede' && device.id === 4) { //BUS_R800
			const find = this.listSelR.find(sc => sc.id === 1); // BUS_KEYPAD
			const qt = find.quantity;
			for (let i = 0; i < qt; i++) {
				this.subtractOne(find);
			}
		}
		if (device.quantity > 0) {
			device.quantity--;
			//this.totalPower = Number((this.totalPower - device.power).toFixed(2));
			switch (device.family) {
				case 'Gateway': {
					this.totalGreenLoadGateway = Number((this.totalGreenLoadGateway - device.powerGreen).toFixed(2));
					this.totalGateway--;
					break;
				} case 'Schede': {
					this.totalGreenLoadSchede = Number((this.totalGreenLoadSchede - device.powerGreen).toFixed(2));
					this.totalSchede--;
					break;
				}
				case 'Fotocellule Bus': {
					this.totalGreenLoadFotocelluleBus = Number((this.totalGreenLoadFotocelluleBus - device.powerGreen).toFixed(2));
					this.totalFotocelluleBus--;
					break;
				}
				case 'Selettori Bus': {
					this.totalGreenLoadSelettoriBus = Number((this.totalGreenLoadSelettoriBus - device.powerGreen).toFixed(2));
					this.totalSelettoriBus--;
					break;
				}
				case 'Interfacce Bus': {
					this.totalGreenLoadInterfaccieBus = Number((this.totalGreenLoadInterfaccieBus - device.powerGreen).toFixed(2));
					this.totalInterfaccieBus--;
					break;
				}
				case 'Lampeggianti Bus': {
					this.totalGreenLoadLampeggiantiBus = Number((this.totalGreenLoadLampeggiantiBus - device.powerGreen).toFixed(2));
					this.totalLampeggiantiBus--;
					break;
				}
				case 'Fotocellule': {
					this.totalGreenLoadFotocelluleOld = Number((this.totalGreenLoadFotocelluleOld - device.powerGreen).toFixed(2));
					this.totalFotocelluleOld--;
					break;
				}
				case 'Selettori': {
					this.totalGreenLoadSelettoriOld = Number((this.totalGreenLoadSelettoriOld - device.powerGreen).toFixed(2));
					this.totalSelettoriOld--;
					break;
				}
				case 'Lampeggianti': {
					this.totalGreenLoadLampeggiantiOld = Number((this.totalGreenLoadLampeggiantiOld - device.powerGreen).toFixed(2));
					this.totalLampeggiantiOld--;
					break;
				}
			}
			if (device.family === 'Gateway') {
				//this.resetFormGateway();
			}
		}
		this.calculateDisabledAddDevice();
	}

	addOne(device: AccessoryPower) {
		if (device.family === 'Fotocellule' && device.id === 2) {
			this.showDialog2();
			return;
		}
		if (device.family === 'Gateway' && device.id === 4) {//BUS_RSLV
			this.showDialog2();
			return;
		}
		if (device.family === 'Gateway' && device.id === 5) {//BUS_RGSM
			this.showDialog2();
			return;
		}
		if (device.family === 'Gateway' && device.id === 6) {//BUS_GATEWAY_4G
			this.showDialog2();
			return;
		}
		if (device.family === 'Schede' && device.id === 3) { //BUS_R700
			this.maxSelettoriOld = 2;
		}
		if (device.family === 'Schede' && device.id === 4) { //BUS_R800
			this.maxSelettoriOld = 4;
		}
		device.quantity++;
		//this.totalPower = Number((this.totalPower + device.power).toFixed(2));
		switch (device.family) {
			case 'Gateway': {
				this.totalGreenLoadGateway = Number((this.totalGreenLoadGateway + device.powerGreen).toFixed(2));
				this.totalGateway++;
				break;
			}
			case 'Schede': {
				this.totalGreenLoadSchede = Number((this.totalGreenLoadSchede + device.powerGreen).toFixed(2));
				this.totalSchede++;
				break;
			}
			case 'Fotocellule Bus': {
				this.totalGreenLoadFotocelluleBus = Number((this.totalGreenLoadFotocelluleBus + device.powerGreen).toFixed(2));
				this.totalFotocelluleBus++;
				break;
			}
			case 'Selettori Bus': {
				this.totalGreenLoadSelettoriBus = Number((this.totalGreenLoadSelettoriBus + device.powerGreen).toFixed(2));
				this.totalSelettoriBus++;
				break;
			}
			case 'Interfacce Bus': {
				this.totalGreenLoadInterfaccieBus = Number((this.totalGreenLoadInterfaccieBus + device.powerGreen).toFixed(2));
				this.totalInterfaccieBus++;
				break;
			}
			case 'Lampeggianti Bus': {
				this.totalGreenLoadLampeggiantiBus = Number((this.totalGreenLoadLampeggiantiBus + device.powerGreen).toFixed(2));
				this.totalLampeggiantiBus++;
				break;
			}
			case 'Fotocellule': {
				this.totalGreenLoadFotocelluleOld = Number((this.totalGreenLoadFotocelluleOld + device.powerGreen).toFixed(2));
				this.totalFotocelluleOld++;
				break;
			}
			case 'Selettori': {
				this.totalGreenLoadSelettoriOld = Number((this.totalGreenLoadSelettoriOld + device.powerGreen).toFixed(2));
				this.totalSelettoriOld++;
				break;
			}
			case 'Lampeggianti': {
				this.totalGreenLoadLampeggiantiOld = Number((this.totalGreenLoadLampeggiantiOld + device.powerGreen).toFixed(2));
				this.totalLampeggiantiOld++;
				break;
			}
		}
		this.calculateDisabledAddDevice();
	}

	calculateDisabledAddDevice(): void {

		// POWER
		this.totalGreenPower = Number((this.totalGreenLoadBoard + this.totalGreenLoadSchede + this.totalGreenLoadGateway + this.totalGreenLoadSelettoriBus +
			this.totalGreenLoadFotocelluleBus + this.totalGreenLoadLampeggiantiBus +
			this.totalGreenLoadInterfaccieBus + this.totalGreenLoadSelettoriOld + this.totalGreenLoadFotocelluleOld + this.totalGreenLoadLampeggiantiOld).toFixed(2));


		if (this.totalGreenLoadSelettoriBus + this.totalGreenLoadFotocelluleBus + this.totalGreenLoadLampeggiantiBus +
			this.totalGreenLoadInterfaccieBus > 0) { // IF BUS ACTIVE ADD 0.2W 
			this.totalGreenPower = Number((this.totalGreenPower + 0.2).toFixed(2));
		}

		const delta = Number((this.busSelect.maxPowerGreen - this.totalGreenPower).toFixed(2));

		// GREEN POWER

		for (const gateway of this.listGateway) {
			gateway.disableAdd = this.totalGateway === this.maxGateway || gateway.quantity > 0 || [2, 12, 13, 14].includes(this.busSelect.id);
			gateway.disableRemove = gateway.quantity === 0;
		}

		//BX704_ZBX7N-1
		//BX608_ZBX6N-2
		//BKV_ZN7-3
		//BKV_RAPID_ZN7-4
		//ZL65-5
		//FA7024CB_ZL65-6
		//FTX20DGC_ZL65-7
		//VER_ZL57-8
		//ZLX24M-9
		//ZLX24S-10
		//ZM3E-11
		//ZF1N-12
		//FA70230CB_ZF1N-13
		//EMEGA_ZL43-14
		//BKX_ZBB3-15
		//ZLB24S-16
		for (const scheda of this.listSchede) {
			if (scheda.id === 1) {// Custom for BUS_AF43S_AF868
				scheda.disableAdd = scheda.powerGreen > delta || scheda.quantity > 0;
			} else if (scheda.id === 2) {// Custom for BUS_RIO
				scheda.disableAdd = scheda.powerGreen > delta || scheda.quantity > 0 || [2, 11, 12, 13, 14].includes(this.busSelect.id);
			} else if (scheda.id === 3) {// Custom for BUS_R700
				const find = this.listSchede.find(sc => sc.id === 4);
				scheda.disableAdd = scheda.quantity > 0 || find.quantity > 0 || this.busSelect.cxn > 0 || [2, 12, 13, 14].includes(this.busSelect.id);
			} else if (scheda.id === 4) {// Custom for BUS_R800
				const find = this.listSchede.find(sc => sc.id === 3);
				scheda.disableAdd = scheda.quantity > 0 || find.quantity > 0 || this.busSelect.cxn > 0 || [2, 12, 13, 14].includes(this.busSelect.id);
			} /*else if (scheda.id === 5) {// Custom for BUS_RCXN
				scheda.disableAdd = scheda.quantity > 0 || this.busSelect.id !== 5; //ZLX230
			}*/
			scheda.disableRemove = scheda.quantity === 0;
		}
		for (const fotocellula of this.listFotocelluleBus) {
			fotocellula.disableAdd = this.totalFotocelluleBus === this.maxFotocelluleBus;
			fotocellula.disableRemove = fotocellula.quantity === 0;
		}
		for (const selettore of this.listSelettoriBus) {
			selettore.disableAdd = this.totalSelettoriBus === this.maxSelettoriBus;
			selettore.disableRemove = selettore.quantity === 0;
		}
		for (const interfaccia of this.listInterfaccieBus) {
			interfaccia.disableAdd = this.totalInterfaccieBus === this.maxInterfaccieBus;
			interfaccia.disableRemove = interfaccia.quantity === 0;
		}
		for (const lampeggiante of this.listLampeggiantiBus) {
			lampeggiante.disableAdd = this.totalLampeggiantiBus === this.maxLampeggiantiBus;
			lampeggiante.disableRemove = lampeggiante.quantity === 0;
		}
		for (const fotocellula of this.listFotocell) {
			fotocellula.disableAdd = this.totalFotocelluleOld === this.maxFotocelluleOld;
			fotocellula.disableRemove = fotocellula.quantity === 0;
		}
		for (const selettore of this.listSelR) {
			selettore.disableAdd = this.totalSelettoriOld === this.maxSelettoriOld;
			selettore.disableRemove = selettore.quantity === 0;
		}
		for (const lampeggiante of this.listLampeggiantiOld) {
			lampeggiante.disableAdd = this.totalLampeggiantiOld === this.maxLampeggiantiOld;
			lampeggiante.disableRemove = lampeggiante.quantity === 0;
		}
		//----------GREEN POWER----------------
		this.totalGreenLoadBusPercentage = Math.floor(this.totalGreenPower / this.busSelect.maxPower * 100);
		this.totalGreenLoadBoardPercentage = Math.floor(this.totalGreenLoadBoard / this.busSelect.maxPower * 100);
		this.totalGreenLoadGatewayPercentage = Math.floor(this.totalGreenLoadGateway / this.busSelect.maxPower * 100);
		this.totalGreenLoadSchedePercentage = Math.floor(this.totalGreenLoadSchede / this.busSelect.maxPower * 100);
		this.totalGreenLoadFotocelluleBusPercentage = Math.floor(this.totalGreenLoadFotocelluleBus / this.busSelect.maxPower * 100);
		this.totalGreenLoadSelettoriBusPercentage = Math.floor(this.totalGreenLoadSelettoriBus / this.busSelect.maxPower * 100);
		this.totalGreenLoadInterfaccieBusPercentage = Math.floor(this.totalGreenLoadInterfaccieBus / this.busSelect.maxPower * 100);
		this.totalGreenLoadLampeggiantiBusPercentage = Math.floor(this.totalGreenLoadLampeggiantiBus / this.busSelect.maxPower * 100);
		this.totalGreenLoadFotocelluleOldPercentage = Math.floor(this.totalGreenLoadFotocelluleOld / this.busSelect.maxPower * 100);
		this.totalGreenLoadSelettoriOldPercentage = Math.floor(this.totalGreenLoadSelettoriOld / this.busSelect.maxPower * 100);
		this.totalGreenLoadLampeggiantiOldPercentage = Math.floor(this.totalGreenLoadLampeggiantiOld / this.busSelect.maxPower * 100);
		//-----------GREEN POWER---------------

		this.totalLoadBoardPercentageLimitGreenPower = Math.floor(this.totalGreenLoadBoard / this.busSelect.maxPowerGreen * 100);
		this.totalLoadGatewayPercentageLimitGreenPower = Math.floor(this.totalGreenLoadGateway / this.busSelect.maxPowerGreen * 100);
		this.totalLoadSchedePercentageLimitGreenPower = Math.floor(this.totalGreenLoadSchede / this.busSelect.maxPowerGreen * 100);
		this.totalLoadFotocelluleBusPercentageLimitGreenPower = Math.floor(this.totalGreenLoadFotocelluleBus / this.busSelect.maxPowerGreen * 100);
		this.totalLoadSelettoriBusPercentageLimitGreenPower = Math.floor(this.totalGreenLoadSelettoriBus / this.busSelect.maxPowerGreen * 100);
		this.totalLoadInterfaccieBusPercentageLimitGreenPower = Math.floor(this.totalGreenLoadInterfaccieBus / this.busSelect.maxPowerGreen * 100);
		this.totalLoadLampeggiantiBusPercentageLimitGreenPower = Math.floor(this.totalGreenLoadLampeggiantiBus / this.busSelect.maxPowerGreen * 100);
		this.totalLoadFotocelluleOldPercentageLimitGreenPower = Math.floor(this.totalGreenLoadFotocelluleOld / this.busSelect.maxPowerGreen * 100);
		this.totalLoadSelettoriOldPercentageLimitGreenPower = Math.floor(this.totalGreenLoadSelettoriOld / this.busSelect.maxPowerGreen * 100);
		this.totalLoadLampeggiantiOldPercentageLimitGreenPower = Math.floor(this.totalGreenLoadLampeggiantiOld / this.busSelect.maxPowerGreen * 100);
		this.elaborateGraphic();
	}

	elaborateGraphic(): void {
		this.statusLimitGreenPower = 0;
		//maxGateway-0-red
		//maxSchede-1-purple
		//maxSelettoriBus-2-orange
		//maxFotocelluleBus-3-green
		//maxInterfaccieBus-4-blue
		//maxLampeggiantiBus-5-pink
		//maxSelettoriOld-6-lightorange
		//maxFotocelluleOld-7-lightgreen
		//maxLampeggiantiOld-8-lightblue
		const deltaLimitGreenPower = 100 - this.totalLoadBoardPercentageLimitGreenPower - this.totalLoadGatewayPercentageLimitGreenPower -
			this.totalLoadSchedePercentageLimitGreenPower - this.totalLoadFotocelluleBusPercentageLimitGreenPower -
			this.totalLoadSelettoriBusPercentageLimitGreenPower - this.totalLoadInterfaccieBusPercentageLimitGreenPower -
			this.totalLoadLampeggiantiBusPercentageLimitGreenPower - this.totalLoadFotocelluleOldPercentageLimitGreenPower -
			this.totalLoadSelettoriOldPercentageLimitGreenPower - this.totalLoadLampeggiantiOldPercentageLimitGreenPower;
		this.valueGreenPower = [];
		if (this.totalGreenPower === this.busSelect.maxPowerGreen) {
			this.valueGreenPower.push({ color: 'yellow', value: this.totalLoadBoardPercentageLimitGreenPower + deltaLimitGreenPower });
		} else {
			this.valueGreenPower.push({ color: 'yellow', value: this.totalLoadBoardPercentageLimitGreenPower });
		}
		if (this.busSelect.maxGateway > 0) {
			this.valueGreenPower.push({ color: 'RosyBrown', value: this.totalLoadGatewayPercentageLimitGreenPower });
		}
		if (this.busSelect.maxSchede > 0) {
			this.valueGreenPower.push({ color: 'purple', value: this.totalLoadSchedePercentageLimitGreenPower });
		}
		if (this.busSelect.maxSelettoriBus > 0) {
			this.valueGreenPower.push({ color: 'orange', value: this.totalLoadSelettoriBusPercentageLimitGreenPower });
		}
		if (this.busSelect.maxFotocelluleBus > 0) {
			this.valueGreenPower.push({ color: 'green', value: this.totalLoadFotocelluleBusPercentageLimitGreenPower });
		}
		if (this.busSelect.maxInterfaccieBus > 0) {
			this.valueGreenPower.push({ color: 'blue', value: this.totalLoadInterfaccieBusPercentageLimitGreenPower });
		}
		if (this.busSelect.maxLampeggiantiBus > 0) {
			this.valueGreenPower.push({ color: 'pink', value: this.totalLoadLampeggiantiBusPercentageLimitGreenPower });
		}
		if (this.busSelect.maxSelettoriOld > 0) {
			this.valueGreenPower.push({ color: 'brown', value: this.totalLoadSelettoriOldPercentageLimitGreenPower });
		}
		if (this.busSelect.maxFotocelluleOld > 0) {
			this.valueGreenPower.push({ color: 'lightgreen', value: this.totalLoadFotocelluleOldPercentageLimitGreenPower });
		}
		if (this.busSelect.maxLampeggiantiOld > 0) {
			this.valueGreenPower.push({ color: 'lightblue', value: this.totalLoadLampeggiantiOldPercentageLimitGreenPower });
		}
		//--------------------------

		if (this.totalGreenPower < this.busSelect.maxPowerGreen) {
			this.valueGreenPower.push({ color: '#E5E6E7', value: deltaLimitGreenPower });
		}

		if (this.totalGreenPower > this.busSelect.maxPowerGreen) {
			this.valueGreenPower = [{ color: 'red', value: 100 }]
			this.statusLimitGreenPower = 2;
			this.showDialog();
		}


		const calcx = this.calcPropLimit(this.totalGreenPower);
	}

	canAddAlertVisibleDevice(device: AccessoryPower): string {
		/*if (this.enableGreenPower && device.limitGreenPower > 0 && this.maxPowerNorm < 1) {
			return 'text-green-600';
		}
		if (device.power + this.totalPower > this.maxPowerNorm) {
			return 'text-50';
		} if (this.enableGreenPower && device.power + this.totalPower <= this.maxPowerNorm) {
			return 'text-green-600';
		}*/
		return '';
	}

	showDialog(): void {
		this.acceptButtonStyle = "p-button-danger";
		this.rejectButtonStyle = "p-button-secondary";
		this.confirmationService.confirm({
			header: this.translate.instant('BUS_MAX_POWER_TITLE'),
			message: this.translate.instant('BUS_MAX_POWER_WARNING'),
			//acceptLabel: this.translate.instant('REMOVE'),
			rejectLabel: this.translate.instant('CLOSE'),
			icon: 'pi cm-alert',

			accept: () => {
				this.busChange();
			},
			reject: () => {
			}
		});
	}


	showDialog2(): void {
		this.acceptButtonStyle = "p-button-danger";
		this.rejectButtonStyle = "p-button-secondary";
		this.confirmationService.confirm({
			header: this.translate.instant('BUS_INCOMPATIBLE_TITLE'),
			message: this.translate.instant('BUS_INCOMPATIBLE_WARNING'),
			//acceptLabel: this.translate.instant('REMOVE'),
			rejectLabel: this.translate.instant('CLOSE'),
			icon: 'pi cm-alert',

			accept: () => {
				this.busChange();
			},
			reject: () => {
			}
		});
	}


	//----0.5  --->10
	//----0.8  --->25
	//----2  --->45
	//----8  --->70
	//----40  --->100
	calcPropLimit(totLimitGreenNorm: number): number {

		//----0.5
		if (totLimitGreenNorm === 0.5) {
			return 10;
		}
		if (totLimitGreenNorm < 0.5) {
			return Math.floor(totLimitGreenNorm / 10 * 100);
		}
		//----0.8
		if (totLimitGreenNorm === 0.8) {
			return 25;
		}
		if (totLimitGreenNorm < 0.8) {
			return 10 + Math.floor((totLimitGreenNorm - 0.5) / 15 * 100);
		}
		//----2
		if (totLimitGreenNorm === 2) {
			return 45;
		}
		if (totLimitGreenNorm < 2) {
			return 25 + Math.floor((totLimitGreenNorm - 0.8) / 20 * 100);
		}
		//----8
		if (totLimitGreenNorm === 8) {
			return 70;
		}
		if (totLimitGreenNorm < 8) {
			return 45 + Math.floor((totLimitGreenNorm - 2) / 25 * 100);
		}
		//----40
		return 70 + Math.floor((totLimitGreenNorm - 8) / 30 * 100);
	}

	calcCollGraph(): string {
		let cont = 0;
		if (this.maxGateway > 0) {
			cont++;
		}
		if (this.maxSchede > 0) {
			cont++;
		}
		if (this.maxFotocelluleBus > 0 || this.maxLampeggiantiBus > 0 || this.maxInterfaccieBus > 0) {
			cont++;
		}
		if (this.maxSelettoriBus > 0) {
			cont++;
		}
		if (this.maxFotocelluleOld > 0 || this.maxSelettoriOld > 0 || this.maxLampeggiantiOld > 0) {
			cont++;
		}

		if (this.onExtendedMobile()) {
			return '';
		}
		if (!this.overTablet()) {
			return '';
		}

		if (cont < 4) {
			return 'col-offset-4';
		}
		if (cont === 5) {
			return 'col-offset-2';
		}
		return '';
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	underMinWidthCol4(): boolean {
		return StandardPageLayout.underMinWidthCol4(this.screenWidth);
	}

	overTablet(): boolean {
		return StandardPageLayout.overTablet(this.screenWidth);
	}

	layoutMarginResponsive(): string {
		return StandardPageLayout.layoutMarginResponsive(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-25rem');
	}

	col3Responsive(): string {
		return StandardPageLayout.col3ResponsiveStd(this.screenWidth);
	}
	col2Responsive(): string {
		return StandardPageLayout.col2ResponsiveStd(this.screenWidth);
	}

	col4Responsive(): string {
		return StandardPageLayout.col4ResponsiveStd(this.screenWidth);
	}

	customPaddingX(): string {
		return StandardPageLayout.customPaddingX(this.screenWidth);
	}

	col12Responsive(): string {
		return StandardPageLayout.col6ResponsiveDesktopTablet(this.screenWidth);
	}

}
